import React from 'react';
import { CustomCellRendererProps } from 'ag-grid-react';
import { getDataBar } from '../helpers';
import { absColDef, AdvancedColDef } from '../helpers/advancedHeader';

const ProgressCellRenderer: React.FC<CustomCellRendererProps> = params => {
  const parsedNumber = parseInt(params.value, 10);
  const { high, low } = params.colDef?.cellRendererParams ?? { high: 100, low: 0 };

  if (parsedNumber >= low && parsedNumber <= high) {
    const range = high - low + 1;
    const colorMultiplier = range === 0 ? 0 : 100 / range;
    const hue = 100 - parsedNumber * colorMultiplier;
    const DataBar = getDataBar({ hue, parsedNumber, range });

    return <DataBar>{`${parsedNumber} / ${high}`}</DataBar>;
  }

  return <span>{params.value}</span>;
};

export const ProgressColDef = (
  colDef: AdvancedColDef,
  progressRange: { high: number; low: number },
): AdvancedColDef => ({
  cellRenderer: ProgressCellRenderer,
  cellRendererParams: progressRange,

  filter: 'agSetColumnFilter',
  filterParams: {
    values: Array.from({ length: progressRange.high - progressRange.low + 1 }, (_, i) => i + progressRange.low),
  },
  ...colDef,
  ...absColDef(colDef),
});
